import React, { useContext, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "./CartContext";
import GameHub from "../games/GameHub";

const GamePlayer = ({ game, onClose }) => {
  const { isUnlocked, updateProgress } = useContext(CartContext);
  const dialog = useRef(null);
  const unlocked = isUnlocked(game.id);
  useEffect(() => {
    const previous = document.activeElement;
    const close = (event) => {
      if (event.key === "Escape") onClose();
      if (event.key === "Tab" && dialog.current) {
        const focusable = [...dialog.current.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), [tabindex]:not([tabindex="-1"])')];
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    };
    document.body.classList.add("modal-open");
    document.addEventListener("keydown", close);
    dialog.current?.focus();
    return () => { document.body.classList.remove("modal-open"); document.removeEventListener("keydown", close); previous?.focus?.(); };
  }, [onClose]);
  return <div className="game-modal" role="presentation" onMouseDown={onClose}>
    <section className="game-dialog" role="dialog" aria-modal="true" aria-labelledby="game-player-title" tabIndex="-1" ref={dialog} onMouseDown={(event) => event.stopPropagation()}>
      <header className="game-dialog__header"><div><p className="eyebrow">{unlocked ? "Full edition unlocked" : "Playable demo"}</p><h2 id="game-player-title">{game.name}</h2></div><button className="icon-button" type="button" aria-label="Exit game" onClick={onClose}>×</button></header>
      <GameHub game={game} unlocked={unlocked} onFinish={(result) => updateProgress(game.id, result)} />
      <footer className="game-dialog__footer"><p><strong>Controls:</strong> {game.demo.controls}</p>{!unlocked && <Link className="button button--quiet button--small" to={`/product/${game.id}`} onClick={onClose}>View full edition</Link>}</footer>
    </section>
  </div>;
};

export default GamePlayer;
